import React from "react";

import { ICommandParameterModel } from "@formant/core/model/commandTemplate";
import { FormControl, FormItem, FormLabel, Input } from "@formant/ui-kit";

interface INumberParameterProps {
    param: ICommandParameterModel;
    onUpdate: (updates: Partial<ICommandParameterModel>) => void;
}

export const NumberParameter: React.FC<INumberParameterProps> = ({
    param,
    onUpdate,
}) => {
    return (
        <div className="space-y-4">
            <FormItem>
                <FormLabel>Default Value</FormLabel>
                <FormControl>
                    <Input
                        type="number"
                        value={String(param.value)}
                        onChange={e =>
                            onUpdate({ value: Number(e.target.value) })
                        }
                        placeholder="Default value"
                        step="any"
                    />
                </FormControl>
            </FormItem>
        </div>
    );
};
